import React from 'react';

const Ribbon = () => (
  <svg
    className="favorites-ribbon"
    height="16"
    viewBox="0 0 12 16"
    xmlns="http://www.w3.org/2000/svg"
    width="12"
  >
    <path
      fill="none"
      fillRule="evenodd"
      stroke="#999"
      strokeWidth=".5"
      d="M5.989 11.54L1 15V1h10v14z"
    />
  </svg>
);

export default Ribbon;
